module.exports = __webpack_public_path__ + "assets/img/free_22.6fcad3eb.png";